jQuery.getFromStorage = function (key) {
    return localStorage.getItem(key);
};

function compareNomeProdotto(a, b) {
    if (a.Prodotto.Name < b.Prodotto.Name)
        return -1;

    return 1;
}

function compareDescrizione(a, b) {
    if (a.Descrizione < b.Descrizione)
        return -1;

    return 1;
}

$.fn.removeClassPrefix = function (prefix) {

    this.each(function (i, it) {
        var classes = it.className.split(" ")
            .map(function (item) {
                return item.indexOf(prefix) === 0 ? "" : item;
            });
        //it.className = classes.join(" ");
        it.className = $.trim(classes.join(" "));

    });

    return this;
};

Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
}


function acEnableTracking() {
    var expiration = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30);
    document.cookie = "ac_enable_tracking=1; expires= " + expiration + "; path=/";
    acTrackVisit();
}

function acTrackVisit() {
    var trackcmp_email = '@ViewBag.ContactUser'
    var trackcmp = document.createElement("script");
    trackcmp.async = true;
    trackcmp.type = 'text/javascript';
    trackcmp.src = '//trackcmp.net/visit?actid=1000191228&e=' + encodeURIComponent(trackcmp_email) + '&r=' + encodeURIComponent(document.referrer) + '&u=' + encodeURIComponent(window.location.href);
    var trackcmp_s = document.getElementsByTagName("script");
    if (trackcmp_s.length) {
        trackcmp_s[0].parentNode.appendChild(trackcmp);
    } else {
        var trackcmp_h = document.getElementsByTagName("head");
        trackcmp_h.length && trackcmp_h[0].appendChild(trackcmp);
    }
}


function sendAnalyticsData(bag, additionalParam) {

    //GA4 event
    gtag('event', additionalParam.eventName, {
        'idc': bag.id,
        'partner': additionalParam.nr,
        'clientId': additionalParam.u,
        'area': additionalParam.area,
        'prodotto': additionalParam.productName
    });

    gtag('set', 'user_properties', { 'NomeRivenditore': additionalParam.nr });
    gtag('set', 'user_properties', { 'ClientId': additionalParam.u });
    gtag('set', 'user_properties', { 'IdContratto': bag.id });
    gtag('set', 'user_properties', { 'Area': additionalParam.area });
    gtag('set', 'user_properties', { 'Prodotto': additionalParam.productName });

    //**fine GA4*/
}
